/**
 * Angular import.
 */
import { Component, Input, OnInit } from '@angular/core';
/**
 * Interface import.
 */
import { MemberCountData } from '../../../onboarding/interface/global.model';
/**
 * Service import.
 */
import { NewLanguageService } from './../../../dataservices/new-language/new-language.service';
import { FunCollectionService } from '../../../common/common-functions/fun-collection.service';
@Component({
  selector: 'app-community-member-filter',
  templateUrl: './community-member-filter.component.html',
  styleUrls: ['./community-member-filter.component.scss']
})
export class CommunityMemberFilterComponent implements OnInit {

  /**
   * Get Members Type Filter Data from Community Detail Component
   */
  @Input() membersFilterData;
  /**
   * Member count data.
   */
  @Input() memberCountData: MemberCountData;

  /**
   * Member filter type.
   */
  public filterType = '';
  /**
   * Translations Data
   */
  public translations = {
    key1: this.mls.languageText.community.key38,
    key2: this.mls.languageText.community.key39
  };
  /**
   * Show commnity filter
   */
  public showfilter = false;
  /**
   * Device is mobile or not
   */
  public isMobile: boolean;
  /**
   * Initaile service
   */
  constructor(public mls: NewLanguageService, public fcs: FunCollectionService) { }

  /**
   * On Initialize
   */
  ngOnInit(): void {
    this.isMobile = this.fcs.device_detail.is_mobile;
    this.membersFilterData.filter.forEach((fitem) => {
      fitem['activeState'] = false;
    });
  }

  /**
   * Apply member filter.
   */
  applyMemberFilter(filterType: string): void {
    this.filterType = filterType;
  }
  /**
   * Show filte or hide
   */
  showFilter(index): void {
    this.showfilter = !this.showfilter;
    this.membersFilterData.filter[index]['activeState'] = this.showfilter;
  }

}
